import styled from 'styled-components';
import { device } from '@components/utils/breakpoints';

export const Root = styled.div`
    .Tooltip-Wrapper {
        display: inline-block;
        position: relative;
        margin-left: 0.5rem;
    }

    svg {
        display: inline-block;
        width: 19px;
        height: 19px;
    }

    .Tooltip-Tip {
        position: absolute;
        border-radius: 4px;
        left: 50%;
        transform: translateX(-50%);
        color: ${({ theme }) => `${theme.text}`};
        background: ${({ theme }) => `${theme.hero}`};
        font-size: 14px;
        line-height: 1;
        z-index: 100;
        padding: 1rem;
        width: 10rem;

        @media ${device.md} {
            width: 15rem;
        }
    }

    .tool-tip-border {
        border-radius: 4px;
        border-style: solid;
        border-width: 1px;
        border-color: ${({ theme }) => `${theme.text}`};
    }

    .Tooltip-Tip::before {
        content: '';
        left: 50%;
        border: solid transparent;
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-width: 6px;
        margin-left: calc(6px * -1);
    }

    .Tooltip-Tip.right {
        left: calc(100% + 13px);
        top: 50%;
        transform: translateX(0) translateY(-50%);
    }

    .Tooltip-Tip.right::before {
        left: calc(6px * -1);
        top: 50%;
        transform: translateX(0) translateY(-50%);
        border-right-color: ${(props) =>
            props.$withBorder ? `${props.theme.text}` : `${props.theme.hero}`};
    }

    .Tooltip-Tip.left {
        left: auto;
        right: calc(100% + 13px);
        top: 50%;
        transform: translateX(0) translateY(-50%);
    }

    .Tooltip-Tip.left::before {
        left: auto;
        right: calc(6px * -2);
        top: 50%;
        transform: translateX(0) translateY(-50%);
        border-left-color: ${(props) =>
            props.$withBorder ? `${props.theme.text}` : `${props.theme.hero}`};
    }

    .Tooltip-Tip.bottom {
        top: 1.8rem;
    }

    .Tooltip-Tip.bottom::before {
        bottom: 100%;
        border-bottom-color: ${(props) =>
            props.$withBorder ? `${props.theme.text}` : `${props.theme.hero}`};
    }
`;
